import React, { FC } from 'react';
import styles from '../index.module.css';
// import useRoleContext from 'contexts/role.context';
// import { ENUM_ROLE } from '@cokitchen/cokitchen-auth';
type typeOrderDetailsHeader = {
  totalOrderAmount: number | string;
  totalNoOfBrands: number | string;
  totalNoOfItems: number | string;
  note: string | null;
  cutlery: boolean;
  isProcessing: boolean;
  setShowUpdateModal: (arg: boolean) => void;
};

const OrderDetailsHeader: FC<typeOrderDetailsHeader> = ({
  totalOrderAmount,
  totalNoOfItems,
  totalNoOfBrands,
  note,
  cutlery
  // isProcessing,
  // setShowUpdateModal
}) => {
  // const { role } = useRoleContext();

  // const isCSAdmin = role === ENUM_ROLE.CS_SUPER_ADMIN || role === ENUM_ROLE.CS_ADMIN;

  return (
    <div>
      <div
        className={`text-xs flex flex-wrap ${styles['section-header-2']} py-[12px] justify-normal gap-3 items-center`}>
        <div className='border-left flex gap-4 items-center'>
          <div>
            <h6 className='font-medium text-base text-gray-5'>Order details</h6>
            <p className='text-xs text-gray-8'>
              {totalNoOfBrands} brands, {totalNoOfItems} items
            </p>
          </div>
        </div>
        <p className='ml-auto bg-gray-11 text-gray-5 border border-[#EAECEC] rounded-[40px] p-2'>
          Cutlery:{' '}
          <span className={cutlery ? 'text-blue-5' : 'text-red-5'}>{cutlery ? 'Yes' : 'No'}</span>
        </p>
        <p className='bg-gray-11 text-gray-5 border border-[#EAECEC] rounded-[40px] p-2'>
          {totalOrderAmount}
        </p>
        {/* {isProcessing && isCSAdmin && (
          <button
            onClick={() => setShowUpdateModal(true)}
            className='p-2 border border-[#FDE9AF] bg-[#D5830017] text-[#D58300] rounded-2xl'>
            Update Order
          </button>
        )} */}
      </div>
      {note && (
        <div className='font-semibold uppercase text-xs px-6 pt-2'>
          Cancellation Note: <span className='text-red-5'>{note}</span>
        </div>
      )}
    </div>
  );
};

export default OrderDetailsHeader;
